import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Loader } from '@shared/components/loader/loader.model';

@Component({
    selector: 'loader-progress-bar',
    imports: [CommonModule],
    templateUrl: './progress-bar.component.html',
    styleUrl: './progress-bar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderProgressBarComponent {
  @Input() loader?: Loader;
}
